import Modal from "../shared/Modal";
import {
  Employee,
  FlattenedEmployeeRecord,
  getDefaultUserAvatar,
  Workspace,
} from "winslow-core";
import "./ModalMatchingEmployees.css";
import { useSelector } from "react-redux";
import { selectHrisConnected, selectUser } from "../../redux/features/appData/appDataSlice";
import { useNavigate } from "react-router-dom";

type ModalMatchingEmployeesProps = {
  isOpen: boolean;
  onClose: () => void;
  employees: (Employee | FlattenedEmployeeRecord)[];
  title?: string;
};

export const ModalMatchingEmployees = ({
  isOpen,
  onClose,
  employees,
  title,
}: ModalMatchingEmployeesProps) => {
  const hrisConnected = useSelector(selectHrisConnected);
  const storeUser = useSelector(selectUser);
  const navigate = useNavigate();

  const currentWorkspace = (storeUser?.workspaces?.find(
    (workspace: Workspace) => workspace.id === storeUser?.currentWorkspaceId
  ) || null) as Workspace | null;
  const hasNativeHRIS = Boolean(currentWorkspace?.hasNativeHRIS);

  const getEmployeeDisplayData = (employee: Employee | FlattenedEmployeeRecord) => {
    if (hasNativeHRIS) {
      // Handle FlattenedEmployeeRecord
      const record = employee as FlattenedEmployeeRecord;
      const firstName = record["system-firstName"] || "";
      const lastName = record["system-lastName"] || "";
      const displayName = [firstName, lastName].filter(Boolean).join(" ").trim() || record.workEmail || "Employee";
      const avatar = record.avatarURL || getDefaultUserAvatar(displayName);
      
      return { displayName, avatar };
    } else {
      // Handle Employee
      const emp = employee as Employee;
      const displayName = emp.displayName || emp.email;
      const avatar = emp?.profile?.avatar || getDefaultUserAvatar(displayName);
      
      return { displayName, avatar };
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "512px" }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="matching-employees-modal-container">
        <header className="matching-employees-modal-header">
          {!hrisConnected && (
            <h1
              className="matching-employees-modal-title clickable"
              onClick={() => {
                navigate("/waz/settings/workspaces?tab=4");
              }}>
              Connect HRIS
            </h1>
          )}
          {hrisConnected && (
            <h1 className="matching-employees-modal-title">
              {title ||
                (employees.length === 0
                  ? "No Matching Employees"
                  : employees.length === 1
                    ? "1 Matching Employee"
                    : `${employees.length} Matching Employees`)}
            </h1>
          )}
        </header>

        <div className="matching-employees-list">
          {employees.map((employee) => {
            const { displayName, avatar } = getEmployeeDisplayData(employee);
            return (
              <div key={employee.id} className="matching-employee-item">
                <img
                  src={avatar}
                  alt={displayName}
                  className="matching-employee-avatar"
                />
                <span className="matching-employee-name">
                  {displayName}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};
